module.exports = __webpack_public_path__ + "static/media/19ESCAP52.434d6c78.jpg";